import React from 'react';
import { Tooltip } from 'reactstrap';
import { connect } from "react-redux";
import Spinner from "../../common/spinner";
import { Link } from "react-router-dom";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi"; 

class SelectCondition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            acknowledgeMySelf: this.props.enabledVirtualDashboard ? true : false,
            tooltipOpen: false,
            selectedCondition: 0
        };
    }
    componentDidMount() {
        logUI("MBHWeb.UI.VideoVisit.SelectCondition.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    onAcknowledgeSelected = (e) => {
        if (e.target)
            this.setState({
                acknowledgeMySelf: e.target.checked
            });
        logUI("MBHWeb.UI.VideoVisit.SelectCondition.AcknowledgeSelected", new Date(), Tools.getURLPath());
    }
    isValid() {        
        return true;
    }
    onConditionSelection = (conditionName, conditionId) => {
        const { acknowledgeMySelf } = this.state;
        if (acknowledgeMySelf) {
            this.props.onConditionSelectionChange(conditionName, conditionId);
            this.props.goNext();
        }
        logUI("MBHWeb.UI.VideoVisit.SelectCondition.ConditionSelection", new Date(), Tools.getURLPath());
    }
    toggleToolTip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    render() {
        const { acknowledgeMySelf, tooltipOpen } = this.state;
        const { videoVisitRequest, enabledVirtualDashboard } = this.props;
        const { conditions, isWaiting, isSuccess } = this.props.videoVisitConditions;
        const videoVisitConditions = conditions && conditions.treatableConditions && conditions.treatableConditions.length > 0 ? conditions.treatableConditions : [];
        var conditionUIElements = videoVisitConditions.map((condition, index) => {
            return (
                <div key={index} id={index} className="col-12 col-lg-6">
                    <button className={`btn btn-primary ${!acknowledgeMySelf ? "btn-disabled" : videoVisitRequest && videoVisitRequest.conditionId === condition.conditionId ? "active" : ""}`} onClick={() => this.onConditionSelection(condition.conditionName, condition.conditionId)}>
                        {condition.conditionName}
                    </button>
                </div>
            );
        });
        return (
            <div className="select-condition-container md-width-step" style={this.props.style}>
                {typeof conditions === 'undefined' || isWaiting && !isSuccess
                    ? <Spinner />
                    :
                    <>
                        <div className="row">
                            <div className="col-12 text-center">
                                {enabledVirtualDashboard ? <h1 className="step-heading step-heading-md">What can we help you with during this visit?</h1>
                                    : <div className="step-description">Please acknowledge you're scheduling for yourself then select a condition below.</div>}
                            </div>
                            <div className="col-12 step-form-container">
                                {!enabledVirtualDashboard &&
                                    <div className="row justify-content-center">
                                        <label className="checkbox-container">
                                            <input
                                                type="checkbox"
                                                name="acknowledgeCondition"
                                                onChange={this.onAcknowledgeSelected}
                                            />
                                            <span className="checkmark" />
                                            <span className="checkbox-label">I am scheduling for myself </span>
                                        </label>
                                        <span className="input-icon-append ">
                                            <span className="icon-question" id="tooltip-info" />
                                            <Tooltip innerClassName="text-center" placement="top" isOpen={tooltipOpen} autohide={false} target="tooltip-info" toggle={this.toggleToolTip}>
                                                Urgent care Video On Demand are currently only available for users with their own MyBSWHealth account.
                                    </Tooltip>
                                        </span>
                                    </div>}
                                <div className='row select-conditions'>
                                    {conditionUIElements}
                                </div>
                            </div>
                        </div>
                        {!enabledVirtualDashboard && <div className="row find-doctor">
                            <div className="col-12 maxWidth-content text-center">
                                <span>Don't see an option that works for you?  <Link className="find-doctor-text" to={{ pathname: "/findcare" }}>FIND A DOCTOR</Link></span>
                            </div>
                        </div>}                        
                    </>
                }
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        videoVisitConditions: state.videoVisitScheduling.videoVisitConditions ? state.videoVisitScheduling.videoVisitConditions : {}
    };
};
export default connect(mapStateToProps, null, null, { withRef: true })(SelectCondition);